{
	"tuneValueToSlider": "Tune {{name}} value ({{leftLabel}} to {{rightLabel}}) Slider"
}
